// AutoMapper
import { AutoMap } from '@nartc/automapper';

export class HelpPlanDto {
    @AutoMap() helpPlanTypeId: string;
    @AutoMap() helpPlanId: string;
    @AutoMap() supplierId: string;
    @AutoMap() phoneNumber: string;
    @AutoMap() fax: string;
    @AutoMap() email: string;
    @AutoMap() otdHealthInsuranceAlarmcenter: string;
    @AutoMap() otdTravelInsuranceAlarmcenter: string;
    @AutoMap() request: number;
    @AutoMap() otdDate: string;
    @AutoMap() otdBsn: string;
    @AutoMap() otdIsTransferArrival: boolean;
    @AutoMap() otdIsTransferDeparture: boolean;
    @AutoMap() otdComment: string;
    @AutoMap() hdHealthInsuranceAlarmcenter: string;
    @AutoMap() hdTravelInsuranceAlarmcenter: string;
    @AutoMap() hdRequestFromDate: string;
    @AutoMap() hdRequestToDate: string;
    @AutoMap() hdIsDefinite: boolean;
    @AutoMap() hdIsIntensiveCare: boolean;
    @AutoMap() hdIntensiveCareFromDate: string;
    @AutoMap() hdIntensiveCareToDate: string;
    @AutoMap() hdDepartment: string;
    @AutoMap() hdRoomNumber: string;
    @AutoMap() hdBsn: string;
    @AutoMap() hdIsTransferArrival: boolean;
    @AutoMap() hdIsTransferDeparture: boolean;
    @AutoMap() hdComment: string;
    @AutoMap() tddLinkedHelpPlan: string;
    @AutoMap() tddDateTime: string;
    @AutoMap() tddFrom: string;
    @AutoMap() tddTo: string;
    @AutoMap() tddTransportMode: string;
    @AutoMap() tadLinkedHelpPlan: string;
    @AutoMap() tadDateTime: string;
    @AutoMap() tadFrom: string;
    @AutoMap() tadTo: string;
    @AutoMap() tadTransportMode: string;
    @AutoMap() tdIsTravelneeded: boolean;
    @AutoMap() tdIsTransferArrival: boolean;
    @AutoMap() tdTransferArrivalComment: string;
    @AutoMap() tdIsTransferDeparture: boolean;
    @AutoMap() tdTransferDepartureComment: string;
    @AutoMap() repatMortalRemains: string;
    @AutoMap() rmrComment: string;
    @AutoMap() parentHelpPlanId: string;
    @AutoMap() childrenHelpPlans: any[];
}
